import api from "lib/api/api";
import {
  FETCH_ENROLLED_COURSE_DETAILS_FAILURE,
  FETCH_ENROLLED_COURSE_DETAILS_REQUEST,
  FETCH_ENROLLED_COURSE_DETAILS_SUCCESS,
} from "../Actions/types";

// Action to fetch enrolled course details for a student and teacherCourseId
export const fetchEnrolledCourseDetails =
  (teacherCourseId) => async (dispatch) => {
    dispatch({ type: FETCH_ENROLLED_COURSE_DETAILS_REQUEST });

    try {
      const response = await api.get(`/enrollment/student/${teacherCourseId}`, {
        withCredentials: true,
      });

      // Check if the response is a message instead of data
      if (typeof response.data === "string") {
        dispatch({
          type: FETCH_ENROLLED_COURSE_DETAILS_FAILURE,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_ENROLLED_COURSE_DETAILS_SUCCESS,
          payload: response.data,
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Error fetching course details!";
      dispatch({
        type: FETCH_ENROLLED_COURSE_DETAILS_FAILURE,
        payload: errorMessage,
      });
    }
  };
